// extracted by mini-css-extract-plugin
module.exports =  {"root":"_93444fe79c--root--HS66q","rating":"_93444fe79c--rating--MTWZA","reviews-count":"_93444fe79c--reviews-count--CTgF8","dot":"_93444fe79c--dot--IcZMJ"};